import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import store from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import { getLoanInsuranceActions, executeLoanAction } from '../../../common/LoanFunctions';
import { InformModal } from '../../../../common/SharedComponents';

export const InsuranceActionsButton = ({ data }) => {
    const { dispatch } = store;
    const location = useLocation();

    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });
    const [informModalOpen, set_informModalOpen] = useState(false);

    const onActionClicked = (event, loan) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getLoanInsuranceActions(loan);

        if (actions.length === 0) {
            set_informModalOpen(true);
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const onActionItemClick = (e) => {
        set_actionData({ ...actionData, visible: false });
        executeLoanAction(e.itemData, dispatch, location);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    if (!data) {
        return null;
    }

    return (
        <>
            <button
                id={`action_${data.id}_${data.propertyId}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, data)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available'}
                confirmCallback={() => set_informModalOpen(false)}
            />
        </>
    );
};
